import { Fragment } from "react";
import Card from '../Card/Card';
import './discounts.scss';

const GridDiscounts = () => {

    return (
        <Fragment>
            <section className="discounts max-width-1440">                
                <Card />                       
            </section>
        </Fragment>
    )
}

export default GridDiscounts;